import AlertModal from "../alert-modal";

type ReservationConflictModalProps = {
  modalOpen: boolean;
  closeModal: () => void;
};
export default function ReservationAllConflictModal(props: ReservationConflictModalProps) {
  return (
    <AlertModal
      title={
        <p>
          모든 예약에 중복 건이 존재해
          <br />
          예약이 불가합니다.
        </p>
      }
      content={
        <p style={{ textAlign: "center" }}>
          예약 일시 혹은 예약 반복 조건을 재설정하신 후,
          <br />
          재시도해주세요.
        </p>
      }
      btnTitle="예약 내역 재설정하기"
      onChange={props.closeModal}
      modalIsOpen={props.modalOpen}
      closeModal={props.closeModal}
    />
  );
}
